import { CacheService, DataService } from "base/services";

import { SERVICE_ACCOUNT_PAGE } from "../constants/serviceaccount.constant.js";
const ACCOUNT_ID = window.accountDetails._id;

export const ServiceAccountService = {
  getserviceAccountList(cancelKey = "", params = {}) {
    const query = {
      page_number: params.page_number || 1,
      page_size: params.page_size || SERVICE_ACCOUNT_PAGE
    };
    return CacheService.get({
      key: cancelKey,
      url: `/user/2/${ACCOUNT_ID}/serviceaccount`,
      params: { query }
    });
  },
  searchServiceAccounts(filter, pageNumber = 1, pagesize = 50) {
    return DataService.get(
      `/user/2/${ACCOUNT_ID}/serviceaccount?page_number=${pageNumber}&page_size=${pagesize}`,
      {
        query: { q: filter }
      }
    );
  },
  createServiceAccount(data) {
    return DataService.post(`/user/2/${ACCOUNT_ID}/serviceaccount`, {
      data
    });
  },
  createAccessKey(data, serviceAccountId) {
    return DataService.post(
      `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}/api`,
      {
        data
      }
    );
  },
  updateAccessKey(data, serviceAccountId, accesKeyId) {
    return DataService.update(
      `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}/api/${accesKeyId}`,
      {
        data
      }
    );
  },
  deleteAccessKey(serviceAccountId, apiKey) {
    return DataService.delete(
      `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}/api/${apiKey}`
    );
  },
  getSingleServiceAccount(cancelKey, serviceAccountId) {
    return CacheService.get({
      key: cancelKey,
      url: `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}`
    });
  },
  updateServiceAccountDetails(serviceAccountId, data) {
    return DataService.update(
      `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}`,
      {
        data
      }
    );
  },
  deactivateServiceAccount(serviceAccountId) {
    return DataService.post(
      `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}/deactivate`
    );
  },
  activateServiceAccount(serviceAccountId) {
    return DataService.post(
      `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}/activate`
    );
  },
  serviceAccountAccessKeys(cancelKey, serviceAccountId) {
    return CacheService.get({
      key: cancelKey,
      url: `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}/api?page_number=1&page_size=50`
    });
  },
  serviceAccountUpdateAccesskey(apiKey, data, serviceAccountId) {
    return DataService.update(
      `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}/api/${apiKey}`,
      {
        data
      }
    );
  },
  postImpersanotion(data, key = "") {
    return DataService.post(
      `/accounts/2/${ACCOUNT_ID}/setting/${key}/impersonation`,
      {
        data
      }
    );
  },
  getAssociatedFlows(cancelKey, serviceAccountId) {
    return CacheService.get({
      key: cancelKey,
      url: `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}/flow`
    });
  },
  getAssociatedFlowCount(serviceAccountId) {
    return DataService.get(
      `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}/flow/count`
    );
  },
  getExtendUserAdmins(serviceAccountId) {
    return DataService.get(
      `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}/member`
    );
  },
  addExtendUserAdmins(serviceAccountId, data) {
    return DataService.post(
      `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}/member`,
      {
        data
      }
    );
  },
  deleteSharedServiceAdmins(serviceAccountId, memberId) {
    return DataService.delete(
      `/user/2/${ACCOUNT_ID}/serviceaccount/${serviceAccountId}/member/${memberId}`
    );
  },
  serviceBotProfileBlob(url) {
    return DataService.download(url);
  }
};
